export const onTimeColumns = [
  {
    title: 'date',
    dataIndex: 'date',
    ellipsis: true,
  },

  {
    title: 'Hours',
    dataIndex: 'ontimeLogs',
    align: 'center',
    render: (ontimeLogs) =>
      `${ontimeLogs?.hoursWorked} ${
        ontimeLogs?.ontimeCategory && `(${ontimeLogs?.ontimeCategory})`
      }`,
  },
]
export const hoursBreakColumn = [
  {
    title: 'Task',
    dataIndex: 'taskName',
    ellipsis: true,
    width: '75%',
  },
  {
    title: 'Hours spend',
    dataIndex: 'totalHours',
    render: (totalHours) => totalHours,
    align: 'center',
  },
]
export const leavesBreakColumn = [
  {
    title: 'Date',
    dataIndex: 'date',
    width: '36%',
    align: 'center',
  },
  {
    title: 'Days',
    dataIndex: 'numberOfDays',
    ellipsis: true,
    width: '20%',
    align: 'center',
  },
  {
    title: 'Reason',
    dataIndex: 'reason',
    ellipsis: true,
    width: '58%',
    align: 'center',
  },
]
